'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    theme = Object.assign({}, baseTheme(theme), theme);

    var styleList = _aphroditeJss.StyleSheet.create({
        root: {
            position: 'relative',
            width: theme.width,
            minWidth: theme.minWidth
        },
        list: {
            position: 'absolute',
            // like popup
            zIndex: theme.zOverlay,
            background: theme.listBackground,
            padding: theme.gutter + 'px 0',
            border: '1px solid ' + theme.listBorderColor,
            boxShadow: theme.listBoxShadow,
            overflow: 'hidden',
            top: 'calc(100% + 3px)',
            left: 0,
            width: '100%'
        },
        item: {
            display: 'block',
            fontSize: theme.itemFontSize,
            lineHeight: theme.itemLineHeight,
            color: theme.itemColor,
            width: '100%',
            whiteSpace: 'nowrap',
            backgroundColor: 'transparent',
            border: '0 none',
            fontFamily: theme.fontFamily,
            margin: 0,
            textAlign: 'left',
            padding: theme.gutter + 'px ' + theme.gutter * 2 + 'px',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            outline: '0 none',

            '&:hover': {
                cursor: 'pointer',
                background: theme.hoverItemBackground,
                outline: '0 none'
            },

            '&:focus': {
                cursor: 'pointer',
                background: theme.focusItemBackground,
                outline: '0 none'
            },

            '&:active': {
                cursor: 'pointer',
                background: theme.activeItemBackground,
                outline: '0 none'
            },

            '&.focused': {
                cursor: 'pointer',
                background: theme.focusItemBackground,
                outline: '0 none'
            }
        },
        input: {
            width: '100%'
        }
    });

    return {
        root: (0, _aphroditeJss.css)(styleList.root),
        item: (0, _aphroditeJss.css)(styleList.item),
        list: (0, _aphroditeJss.css)(styleList.list),
        input: (0, _aphroditeJss.css)(styleList.input)
    };
};

var _aphroditeJss = require('aphrodite-jss');

var baseTheme = function baseTheme(theme) {
    return {
        listBackground: theme.elPrimary,
        listBorderColor: theme.elPrimary,
        listBoxShadow: '0 6px 10px 0 ' + theme.elShadow + ', 0 4px 10px 0 ' + theme.elShadow,

        itemFontSize: theme.tsNormal,
        itemLineHeight: 1.5,
        itemColor: theme.tActive,

        hoverItemBackground: theme.elLightest,
        focusItemBackground: theme.elLightest,
        activeItemBackground: theme.elLightest,
        width: 'auto',
        minWidth: 'auto'
    };
};